import { WebLeft, WebWidth } from "../../config/config";
import { isMobile } from "react-device-detect";
import { Colors } from "../../util/colors";
import "../../styles/css/alert-modal.css";
var $ = require("jquery");

function MessageBox({
  Text = String,
  Icon = "success|error|warning|info|question",
  ConfirmButtonText = String,
  ConfirmButtonFunction = () => {},
}) {
  $(".modal").remove();

  $("#MobileView").append(MessageBoxComponent(Text, Icon, ConfirmButtonText));
  var modal = document.getElementById("myModal");
  modal.style.display = "block";
  var span = document.getElementsByClassName("close")[0];

  var ConfirmButton = document.getElementsByClassName("button-61")[0];
  ConfirmButton.style.backgroundColor = Colors.DarkGreyScale;

  if (span) {
    span.onclick = function () {
      ConfirmButtonFunction();
      modal.style.display = "none";
    };
  }
}

function MessageBoxComponent(Text, Icon, ConfirmButtonText) {
  let item = "";

  if (isMobile) {
    item +=
      '<div id="myModal" class="modal" style="position:fixed;height:100%;">';
  } else {
    item +=
      '<div id="myModal" class="modal" style="position:fixed;left:' +
      WebLeft +
      ";width:" +
      WebWidth +
      'px;height:100%;">';
  }
  item += '<div class="modal-content">';
  item += '<div class="modal-header">';
  item += "</div>";
  item += '<div class="modal-body">';
  item +=
    "<p style='margin:3px;font-size:15px;text-align:center;'>" + Text + "</p>";
  item += "    </div>";
  item += '    <div class="modal-footer">';
  item +=
    "      <button class='button-61 close' style='width:80px;'>" +
    ConfirmButtonText +
    "</button>";
  item += "    </div>";
  item += "  </div>";
  item += "</div>";
  return item;
}
export default MessageBox;
